module.exports = __webpack_public_path__ + "img/Yealink_w52p.259ec727.png";